import { LeaveBalanceTableResult } from "@/models/leave-balances.model";
import { LeaveType } from "@/models/leave-types.model";
import { ColumnDef } from "@tanstack/react-table";
import { ArrowUpDown } from "lucide-react";

export const createColumns = (leaveTypes: LeaveType[]): ColumnDef<LeaveBalanceTableResult>[] => {
  // Base column for user name
  const baseColumns: ColumnDef<LeaveBalanceTableResult>[] = [
    {
      id: "user",
      accessorFn: (row) => `${row.user.fullName}`,
      cell: ({ row }) => `${row.original.user.fullName}`,
      header: ({ column }) => {
        return (
          <div className="flex items-left flex-col text-left whitespace-normal break-words h-full">
            <button
              onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
            >
              <ArrowUpDown className="ml-2 h-4 w-4" />
            </button>
            Employee

          </div>
        );
      }
    },
  ];

  // Generate a column for each leave type
  const leaveTypeColumns = leaveTypes.map(leaveType => ({
    size: 100,
    id: `leaveType_${leaveType.id}`,
    accessorFn: (row: LeaveBalanceTableResult) => {
      const balance = row.balances.find(b => b.leaveTypeId === leaveType.id);
      return balance?.balance ?? 0;
    },
    cell: ({ row }: any) => {
      const balance: { leaveTypeId: number; balance: number } | undefined = row.original.balances.find((b: { leaveTypeId: number }) => b.leaveTypeId === leaveType.id);
      return balance?.balance ?? 0;
    },

    header: ({ column }: any) => {
      return (
        <div className="flex flex-col items-left text-left whitespace-normal break-words min-w-[80px] h-full">
          <button
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
            className="mb-1"
          >
            <ArrowUpDown className="h-4 w-4" />
          </button>
          <span>{leaveType.name.split(' ').slice(0, -1).join(' ')}</span>
        </div>
      );
    }
  }));

  return [...baseColumns, ...leaveTypeColumns];
};
